<h1 matDialogTitle>Confirm Sending Email</h1>

<mat-dialog-content>
  <!-- <p>
    Email to send: {{data.email.documentType}}
  </p> -->
  <p>
    Please verify the details below:
  </p>

  <form class="dynamic-form" [formGroup]="form" style="width: 100%">
    <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="16px grid">

      <mat-form-field fxFlex="100" width="100%">
        <mat-label>Name *</mat-label>
        <input #contactPlus matInput type="text" formControlName="name" maxlength="50"
          autocomplete="new-password" v>
        <mat-hint align="end">{{contactPlus.value.length}} / 50</mat-hint>
      </mat-form-field>

      <mat-form-field fxFlex="100" width="100%">
        <mat-label>Email *</mat-label>
        <input #email matInput type="email" formControlName="email" maxlength="255" autocomplete="new-password">
        <mat-hint align="end">{{email.value.length}} / 255</mat-hint>
      </mat-form-field>

    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button matDialogClose>Cancel</button>
  <button mat-button [disabled]="!form.valid" (click)="send()">Send</button>

</mat-dialog-actions>
